<div class="display-flex justify-content-space-between align-items-center gap-1">
  <app-upload-file
    [uploadClass]="'csv-uploader'"
    [listType]="listType"
    [permittedFileTypes]="permittedFileTypes"
    [showUploadList]="false"
    [multipleFiles]="false"
    (fileChange)="handleChange($event)"
    (fileRemove)="removeFile()"
    >
    <ng-container *ngIf="!uploadedFileName">
      <div class="display-flex align-items-center gap-1">
        <span class="upload-icon" nz-icon [nzType]="loading ? 'loading' : 'plus'"></span>
        <div class="ant-upload-text">
          <div>
            <p class="small-font semibold-font">{{uploadText}}</p>
            <p class="smaller-font margin-top-1">{{uploadFileInstruction}}</p>
          </div>
        </div>
      </div>
    </ng-container>
    <div *ngIf="uploadedFileName" class="uploaded-wrapper">
      <div class="uploaded-file">
        <p [ngClass]="{'filename-error-state': hasError}">{{uploadedFileName}}</p>
      </div>
      <div class="text">
        <p>{{uploadText}}</p>
      </div>
    </div>
  </app-upload-file>

  <button *ngIf="uploadedFileName && !hideRemoveBtn" (click)="removeFile()" nz-button nzType="default" nzShape="circle">
    <span nz-icon nzType="delete" nzTheme="outline"></span>
  </button>
</div>